
















































import {Component, Prop, Vue} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import Entries from "@/store/modules/entries";
import {Entry, EntryType} from "@/types/entry";
import {BvModalEvent} from "bootstrap-vue-shims";
import UUIDUtils from "@/utils/UUIDUtils";

@Component
export default class NewEntryComponent extends Vue {

    get titleInvalid(): string {
        if (this.title.length > 3) {
            return "";
        } else if (this.title.length > 0) {
            return "Enter at least 4 characters";
        } else {
            return "Please enter something";
        }
    }

    get titleState(): boolean {
        return this.title.length > 3;
    }

    get typeInvalid(): string {
        return "Please select something from the dropdown";
    }

    get typeState(): boolean {
        return this.type != null && this.type != -1;
    }

    get amountInvalid(): string {
        return "Please enter a valid number larger than zero";
    }

    get amountState(): boolean {
        return !isNaN(this.amount) && this.amount > 0;
    }

    public title: string = "";
    public type: EntryType = -1;
    public amount: number = 0;
    @Prop() private id!: string;

    private entryModule = getModule(Entries);

    public types(): EntryType[] {
        return Object.values(EntryType);
    }

    public handleOk(event: BvModalEvent) {
        this.entryModule.getEntries.push(new Entry(UUIDUtils.generateUUID(), this.type, this.title, this.amount));
        this.reset();
    }

    public handleCancel(event: BvModalEvent) {
        this.reset();
    }

    public reset(): void {
        this.title = "";
        this.type = -1;
        this.amount = 0;
}

    // TODO handle enter and ok here
    // TODO initial focus on title
    // TODO disable ok button until all valid
    // TODO don't make everything red initially, only after first typing
}
